import React from 'react';
import RecuperacaoBoard from './RecuperacaoBoard';

/** Recuperação — pool + área de trabalho (todos os utilizadores CCC). */
const RecuperacaoPage: React.FC = () => {
  return <RecuperacaoBoard />;
};

export default RecuperacaoPage;
